import angular from "angular";

export const select = (input) => {
  if (input != document.activeElement) {
    input.focus({
      preventScroll: true,
    });
  }
  if (angular.isFunction(input.select)) {
    input.select();
  } else if (angular.isFunction(input.setSelectionRange)) {
    input.setSelectionRange(0, input.value.length);
  }
};

const canFocus = ["INPUT", "BUTTON", "SELECT"];

export default ($rootScope, $timeout) => ({
  link: {
    post(scope, element, attr) {
      let input = element[0];
      for (
        var i = 0;
        i < canFocus.length && canFocus.indexOf(input.tagName) < 0;
        i++
      ) {
        var els = element.find(canFocus[i]);
        if (els.length) {
          input = els[0];
          break;
        }
      }

      if (attr.autoFocus) {
        //console.debug("autoFocus setup", attr.autoFocus, input);
        scope.$on(attr.autoFocus, () => {
          //$rootScope
          //  console.info("autoFocus", attr.autoFocus, input, arguments);
          input.focus({
            preventScroll: true,
          });
          if (attr.autoFocusSelect) {
            // console.info("autoFocusSelect", attr.autoFocusSelect);
            $timeout(() => select(input), attr.autoFocusSelectDelay || 250);
          }
        });
        if (attr.autoFocusNow) {
          // console.info("autoFocusNow", attr.autoFocusNow, attr.autoFocusDelay);
          $timeout(
            () => input.focus({ preventScroll: true }),
            attr.autoFocusDelay || attr.autoFocusDelay || 50
          );
        }
      } else {
        $timeout(
          () => input.focus({ preventScroll: true }),
          attr.autoFocusDelay || 50
        );
      }
    },
  },
});
